export const PromData = [
  { id: 20, name: 'SUPER VIP', bgColor: '#FD541A', iconName: 'vip-super-1' },
  { id: 15, name: 'VIP PLUS', bgColor: '#FCC000', iconName: 'vip-plus' },
  { id: 10, name: 'VIP', bgColor: '#3C74FF', iconName: 'vip-basic' },
  { id: 1, name: 'COLOR', bgColor: '#59D8C9', iconName: 'color-i' },
  { id: 2, name: 'AUTO UPDATE', bgColor: '#BB5CF7', iconName: 'automatic-update-promo-icon' },
  { id: 3, name: 'UPDATE', bgColor: '#27B1FF', iconName: 'one-time-update-promo-icon' },
];
